import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import type { ReactNode } from 'react';
import { keyList } from '../../../media/overview/MediaBoardSkeleton.js';

export const TILE_GRID_SX = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: 1,
};

type SectionSkeletonVariant = 'tiles' | 'chart' | 'table';

interface SectionSkeletonProps {
  variant: SectionSkeletonVariant;
  tileCount?: number;
  rowCount?: number;
}

export function SectionSkeleton({
  variant,
  tileCount = 6,
  rowCount = 4,
}: SectionSkeletonProps): ReactNode {
  if (variant === 'tiles') {
    return (
      <Box sx={TILE_GRID_SX}>
        {keyList(tileCount, 'tile').map((key) => (
          <Skeleton key={key} variant="rounded" height={84} />
        ))}
      </Box>
    );
  }

  if (variant === 'chart') {
    return (
      <Box>
        <Skeleton variant="rounded" height={280} />
        <Box sx={{ display: 'flex', gap: 5, pl: 5, mt: 2 }}>
          <Skeleton variant="text" width={80} />
          <Skeleton variant="text" width={80} />
        </Box>
      </Box>
    );
  }

  return (
    <Box>
      {keyList(rowCount, 'row').map((key) => (
        <Box key={key} sx={{ display: 'flex', gap: 4, px: 4, py: 3 }}>
          <Skeleton variant="text" width="30%" />
          <Skeleton variant="text" width="15%" sx={{ ml: 'auto' }} />
          <Skeleton variant="text" width="15%" />
        </Box>
      ))}
    </Box>
  );
}
